const HOME = '/';
const LOGIN = '/sign-in';
const UNSUB = '/unsubscribe';
const REGISTER = '/sign-up';
const RESET_PASSWORD_RAW = '/reset-password';
const RESET_PASSWORD = '/resetPassword/:token';
const CONFIRM_EMAIL = '/activation/:token';

const REGISTER_EXTERNAL = '/sign-up/sso/:code';
const REGISTER_EXTERNAL_PATH = '/sign-up/sso/';
const PROMOTIONS = '/promotions';
const PROMOTION_DETAIL = '/promotions/:promotionId';

const CREATE_ORDER_RAW = '/create-order';
const CREATE_ORDER = '/create-order/:userId/:promoId';
const REDEEM_COUPON = '/redeem-coupon/:id';
const REDEEM_COUPON_RAW = '/redeem-coupon';
const CANCEL_COUPON = '/cancel-coupon/:id';
const CANCEL_COUPON_RAW = '/cancel-coupon';
const COUPONS_LIST = '/my-coupons';
const POST_ROUTER = '/post-router';
const RECOVER_CREDITS = '/recover-saz-coins';
const LOAD_USER = '/load-user';
const PROFILE = '/profile';
const ADDRESS_EDIT = '/change-address/:promoId?';
const ADDRESS_EDIT_RAW = '/change-address/';
const PROFILE_PARAMETER = '/profile/:promotionData';
const TELEPHONE_FORM = '/telephone-form';
const TELEPHONE_FORM_PROMO = '/telephone-form/:promoId?';
const VERIFY_PHONE = '/verify-phone';

const SURVEY_PRE_POST = '/survey/:id/:promoId';
const SURVEY_EXTRA = '/survey-extra/:id/:promoId?';
const SURVEY_SIMULATOR = '/iss/:id/:testId/:qFrom/:userId/:token';

const ROUTER_NEXT_PRE = '/pre-router/:uuid';
const ROUTER_NEXT_POST = '/post-router/:uuid';

const LEGAL_CONDITIONS: string = '/legal-conditions';
const PRIVACY_POLICY: string = '/privacy-policy';
const COOKIES_POLICY: string = '/cookies-policy';
const STATIC_CONTENT_REMOTE: string = '/article/:alias';

const FORCE_ERROR = '/force-front-throw-error';
const CODE_READER = '/code-reader-v1-alpha';
const RR_PAGE = '/rating-and-review/:id';
const RR_PAGE_RAW = '/rating-and-review';
const SURVEY_RAW = '/survey/';
const SURVEY_EXTRA_RAW = '/survey-extra/';
const CALLBACK_GOOGLE = '/oauth/calback';

const whiteListLogin = [
  PROFILE,
  PROMOTIONS,
  PROMOTION_DETAIL,
  CREATE_ORDER_RAW,
  REDEEM_COUPON_RAW,
  CANCEL_COUPON_RAW,
  COUPONS_LIST,
  POST_ROUTER,
  RECOVER_CREDITS,
  TELEPHONE_FORM,
  VERIFY_PHONE,
  RR_PAGE_RAW,
  SURVEY_RAW,
  SURVEY_EXTRA_RAW,
];

export {
  HOME,
  LOGIN,
  REGISTER,
  RESET_PASSWORD_RAW,
  RESET_PASSWORD,
  CONFIRM_EMAIL,
  PROMOTIONS,
  PROMOTION_DETAIL,
  CREATE_ORDER,
  REDEEM_COUPON,
  CANCEL_COUPON,
  COUPONS_LIST,
  POST_ROUTER,
  RECOVER_CREDITS,
  LOAD_USER,
  PROFILE,
  TELEPHONE_FORM,
  TELEPHONE_FORM_PROMO,
  PROFILE_PARAMETER,
  VERIFY_PHONE,
  SURVEY_PRE_POST,
  SURVEY_EXTRA,
  SURVEY_SIMULATOR,
  ROUTER_NEXT_PRE,
  ROUTER_NEXT_POST,
  LEGAL_CONDITIONS,
  PRIVACY_POLICY,
  COOKIES_POLICY,
  STATIC_CONTENT_REMOTE,
  FORCE_ERROR,
  CODE_READER,
  whiteListLogin,
  RR_PAGE,
  ADDRESS_EDIT,
  ADDRESS_EDIT_RAW,
  REGISTER_EXTERNAL,
  REGISTER_EXTERNAL_PATH,
  CALLBACK_GOOGLE,
  UNSUB,
};
